<template>
  <v-card
    outlined
    class="my-2"
    loader-height="8"
    :loading="admin.componentRequirementsLoading"
    :disabled="admin.componentRequirementsLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card>
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text class="text-h5">
          Delete Requirement ({{ id }})?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteComponentRequirement">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="blue lighten-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.detailIcon }}</v-icon>
    </v-toolbar>
    <v-card-text
      v-show="admin.selectedComponentRequirement == null"
    ></v-card-text>
    <v-card-text v-show="admin.selectedComponentRequirement != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Requirement saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field disabled v-model="id" label="ID" readonly></v-text-field>
        <v-autocomplete
          :items="admin.requirementEntityList"
          label="Target"
          outlined
          item-text="name"
          item-value="value"
          v-model="targetEntity"
          :rules="validation.selection"
        ></v-autocomplete>
        <v-autocomplete
          :items="filteredRequirementTypeList"
          label="Requirement Type"
          outlined
          item-text="name"
          item-value="value"
          v-model="requirementType"
          :rules="validation.selection"
        ></v-autocomplete>
        <v-autocomplete
          :items="admin.attributeList"
          label="Attribute"
          outlined
          item-text="name"
          item-value="id"
          v-model="attributeId"
          :rules="validation.selection"
          autofocus
        ></v-autocomplete>
        <!-- Value Controls-->
        <div v-show="valueRequired">
          <v-autocomplete
            outlined
            v-if="controlType == 'dropdownlist'"
            v-model="value"
            :items="
              controlType == 'dropdownlist' ? attributeValuesDropDownList : []
            "
            :loading="admin.attributeValuesLoading"
            label="Value"
            item-text="label"
            item-value="value"
            :rules="valueRequired ? validation.selection : []"
          ></v-autocomplete>

          <v-text-field
            v-if="controlType == 'int'"
            v-model="value"
            :rules="validation.Numeric"
            label="Value"
            required
            autofocus
          ></v-text-field>
          <v-text-field
            v-if="controlType == 'text'"
            v-model="value"
            :rules="validation.length150"
            label="Value"
            required
            autofocus
          ></v-text-field>
          <v-autocomplete
            v-if="controlType == 'multiselect'"
            v-model="value"
            :items="
              controlType == 'multiselect' ? attributeValuesMultiSelect : []
            "
            :loading="admin.attributeValuesLoading"
            :menu-props="{ maxHeight: 200 }"
            attach
            chips
            label="Values"
            multiple
            item-text="label"
            item-value="value"
            deletable-chips
          ></v-autocomplete>
        </div>
        <!-- End Value Controls-->
      </v-form>
    </v-card-text>
    <v-card-actions
      class="mt-16 pt-16"
      v-show="admin.selectedComponentRequirement != null"
    >
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveComponentRequirement"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="cancelCreation">cancel</v-btn>
      <v-btn
        v-show="!isNaN(id)"
        icon
        color="error"
        @click="confirmDeleteRequirement"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmationDialog: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      valueRequired() {
        return (
          this.requirementType !== 'AttributeMatchesSetting' &&
          this.requirementType !== 'AttributeIsAtLeastSetting'
        );
      },
      filteredRequirementTypeList() {
        if (this.targetEntity == 'Product') {
          return this.admin.requirementTypeList.filter(
            (x) => x.value.indexOf('Attribute') == 0
          ); // requirements that start with "Attribute"
        } else if (this.targetEntity == 'ComponentDefinition') {
          return this.admin.requirementTypeList.filter(
            (x) => x.value.indexOf('Setting') == 0
          ); // requirements that start with "Setting"
        }
        return this.admin.requirementTypeList;
      },
      controlType: {
        get() {
          const attributeRecord = this.getSelectedAttribute();
          if (attributeRecord) return attributeRecord.controlType.toLowerCase();
          else return null;
        }
      },
      tabName: {
        get() {
          let tabName = 'Edit';
          if (
            this.admin.selectedComponentRequirement &&
            this.admin.selectedComponentRequirement.id != 'new'
          ) {
            tabName = 'Edit Requirement';
          } else if (
            this.admin.selectedComponentRequirement &&
            this.admin.selectedComponentRequirement.id == 'new'
          ) {
            tabName = 'Add New Requirement';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedComponentRequirement?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentRequirement',
            property: 'id',
            value: value
          });
        }
      },
      attributeId: {
        get() {
          return this.admin.selectedComponentRequirement?.attributeId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentRequirement',
            property: 'attributeId',
            value: Number(value)
          });
          this.$store.dispatch('admin/getAttributeValueList', value);
        }
      },
      requirementType: {
        get() {
          return this.admin.selectedComponentRequirement?.requirementType;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentRequirement',
            property: 'requirementType',
            value: value
          });
        }
      },
      value: {
        get() {
          let currentValue = this.admin.selectedComponentRequirement?.value;
          if (currentValue == null) return null;
          if (this.controlType == 'multiselect' && currentValue)
            return currentValue.split(',');
          else return currentValue;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentRequirement',
            property: 'value',
            value: this.controlType == 'multiselect' ? value.join(',') : value
          });
        }
      },
      attributeValuesDropDownList: {
        get() {
          return this.admin.attributeValueList;
        }
      },
      attributeValuesMultiSelect: {
        get() {
          return this.admin.attributeValueList;
        }
      },
      targetEntity: {
        get() {
          return this.admin.selectedComponentRequirement?.targetEntity;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentRequirement',
            property: 'targetEntity',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Returns an attribute record for the currently selected PAV
       */
      getSelectedAttribute() {
        const attributeRecord = this.admin.attributeList.find(
          (x) => x.id == this.admin.selectedComponentRequirement?.attributeId
        );
        if (attributeRecord) return attributeRecord;
        else return null;
      },
      /**
       * Cancels upsert of a component
       */
      cancelCreation() {
        this.$store.commit('admin/setSelectedComponentRequirement', null);
      },
      /**
       * Saves the component currently being edited
       */
      saveComponentRequirement() {
        this.$store
          .dispatch('admin/saveSelectedComponentRequirement')
          .then(() => {
            this.showSaveOverlay = true;
            // refresh component list
            this.$store.dispatch('admin/getComponentRequirementList');
            setTimeout(() => {
              this.showSaveOverlay = false;
            }, 1500);
          });
      },
      /**
       * Show confirm dialog
       */
      confirmDeleteRequirement() {
        this.showConfirmationDialog = true;
      },
      /**
       * Deletes a a product requirement
       */
      deleteComponentRequirement() {
        this.$store
          .dispatch('admin/deleteComponentRequirement', this.id)
          .then(() => {
            this.$store.dispatch('admin/getComponentRequirementList');
            this.showConfirmationDialog = false;
            this.$store.commit('admin/setSelectedComponentRequirement', null);
          });
      }
    }
  };
</script>

<style>
  .v-menu__content
    .theme--dark
    .menuable__content__active
    .v-autocomplete__content {
    max-height: 200px !important; /* Adjust this value as needed */
    overflow-y: auto;
  }
</style>
